"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerLanguages = exports.registerLanguage = exports.registerDefaultLanguages = exports.isValidCountryCode = exports.getName = exports.getCode = void 0;

var _i18nIsoCountries = _interopRequireDefault(require("i18n-iso-countries"));

var _Logger = _interopRequireDefault(require("./Logger"));

/* eslint-disable import/no-dynamic-require */

/* eslint-disable global-require */
var DEFAULT_LANGUAGES = ['en', 'sv', 'es', 'no', 'fi'];
var _languages = [];

var getCode = function getCode(country) {
  if (!country) {
    // Logger.error('You must send a country as a parameter to get the code.');
    return null;
  }

  var code = null;

  _languages.forEach(function (language) {
    if (!code) {
      var result = _i18nIsoCountries["default"].getAlpha2Code(country, language);

      if (result) {
        code = result;
      }
    }
  });

  return code;
};

exports.getCode = getCode;

var getName = function getName(code, language) {
  if (!code || !language) {
    return null;
  }

  var name = _i18nIsoCountries["default"].getName(code, language, {
    select: 'official'
  });

  if (!name) {
    _Logger["default"].error("Country ".concat(code, " name can't be found in ").concat(language, " language"));

    return null;
  }

  return name;
};

exports.getName = getName;

var isValidCountryCode = function isValidCountryCode(code) {
  return _i18nIsoCountries["default"].isValid(code);
};

exports.isValidCountryCode = isValidCountryCode;

var registerLanguage = function registerLanguage(language) {
  if (!language) return;

  var _language;

  var localeObject; // Allow sending locale string or i18n-iso-countries json to avoid dynamic import

  if (typeof language === 'string') {
    localeObject = require("i18n-iso-countries/langs/".concat(language, ".json")); // eslint-disable-next-line prefer-destructuring

    _language = language.split('-')[0];
  } else {
    localeObject = language;
    _language = language.locale;
  }

  if (!_languages.includes(_language)) {
    _i18nIsoCountries["default"].registerLocale(localeObject);

    _languages.push(_language); // Logger.info(`Registered new language: ${_language}`);

  } else {// Logger.info(`Language not registered because it was already registered: ${_language}`);
  }
};

exports.registerLanguage = registerLanguage;

var registerLanguages = function registerLanguages() {
  var languages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  languages.forEach(registerLanguage);
};

exports.registerLanguages = registerLanguages;

var registerDefaultLanguages = function registerDefaultLanguages() {
  registerLanguage(DEFAULT_LANGUAGES);
};

exports.registerDefaultLanguages = registerDefaultLanguages;